module.exports = __webpack_public_path__ + "b2cbaba3eef63b01e7e83eecc01f54f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/404-illustration.svg
// module id = 2540
// module chunks = 0